// primaries
export const primaryPadding = '10px';

//adaptive
export const xs = '374px';
